module.exports = __webpack_public_path__ + "img/signal-128x128-transp.22c9c8dc.png";